import { useMemo } from 'react';
import { useApi } from 'src/new_arch/providers/ApiProvider';
import FeatureFlagsSystem from './FeatureFlagsSystem';

const useFeatureFlagsSystem = () => {
	const api = useApi();
	return useMemo( () => new FeatureFlagsSystem( { api } ), [ api ] );
}

export default useFeatureFlagsSystem;
